export default __webpack_public_path__ + "static/media/calender.fa6eae15.svg";